module.exports = __webpack_public_path__ + "static/media/Zuivel.1f50d48c.svg";